// extracted by mini-css-extract-plugin
export var closeButton = "_x-1";
export var container = "_x-0";
export var fullModalImage = "_x-2";